/**
 * SEC-020: PDF/raw HTML 조립용 HTML 이스케이프 유틸.
 * 사용자 통제 자유텍스트를 html2pdf 렌더 컨텍스트에 안전하게 삽입.
 * & 를 먼저 치환(이중 이스케이프 방지) 후 < > " ' 치환. null/undefined→''.
 */

/** 속성·텍스트 컨텍스트 공용 HTML escape (5종 치환). */
export const escapeHtmlAttr = (v) => {
  if (v === null || v === undefined) return '';
  return String(v)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
};

/** 텍스트 컨텍스트 alias — 속성/텍스트 모두 5종 치환으로 안전(over-escape 무해). */
export const escapeHtml = escapeHtmlAttr;
